import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { LastPlayedGamesComponent } from './last-played-games.component';



@NgModule({
  declarations: [
    LastPlayedGamesComponent
  ],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
  ],
  exports: [LastPlayedGamesComponent]
})
export class LastPlayedGamesModule { }
